import { render, staticRenderFns } from "./WeddingAplication.vue?vue&type=template&id=5ca2ce06&"
import script from "./WeddingAplication.vue?vue&type=script&lang=js&"
export * from "./WeddingAplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports